<template>
    <div class="items-list-app h-100" :class="advancedView ? 'container-fluid' : 'container-xl'">
        <div class="row h-100">
            <div class="col h-100">
                
                <div class="h-100 d-flex flex-column">
                    
                    <div class="mb-3 pt-4 d-flex justify-content-between align-items-end">  <!-- HEADER SECTION -->
                        <div>
                            <div class="d-flex gap-3 align-items-center">
                                <h1>Items</h1>
                                <b-link href="#" class="text-uppercase font-size-70" @click="toggleAdvancedView">
                                    <b-icon icon="arrow-repeat"></b-icon>
                                    {{ advancedView ? "Switch to Basic View" : "Switch to Advanced View" }}
                                </b-link>
                            </div>
                            <p class="lead mb-0">View and manage all purchased items.</p>
                        </div>
                        <div class="">
                            <b-button
                            v-if="canAdd"
                                variant="success"
                                @click="startCreate"
                            >
                                <b-icon icon="plus-circle" class="mr-1"></b-icon>
                                Add Item
                            </b-button>
                        </div>
                        
                    </div>

                    <div v-if="isInitialAdvancedViewSet" class="w-100 flex-fill pb-4">  <!-- LIST SECTION -->
                        <div v-if="advancedView" class="h-100">
                            <object-grid
                                ref="itemsObjectGrid"
                                model-class="Product"
                                class="h-100"
                                grid-max-height="100%"
                                :col-state-local-storage-key="'product-list'"
                                :block-size="100"
                            ></object-grid>
                        </div>

                        <item-list 
                            v-else
                            ref="basicItemList" 
                            class="h-100"
                        ></item-list>  <!-- do we need to listen for 'request-create' or similar event? -->
                    </div>

                </div>
            </div>
        </div>
        <!-- <ResourceModal ref="modal" @saved="onResourceSaved" /> -->
        <!-- MODAL for adding -->
        <item-create-update-modal
            ref="createModal"
            :redirect-after-create="true"
            @create-complete="afterCreateComplete"
        ></item-create-update-modal>
    </div>
</template>

<script>
// import ResourceModal from "@/components/resources/ResourceModal";
// import VendorList from "@/components/vendors/components/VendorList";
import { currentUserInfoMixin, tenantInfoMixin } from '@/js/custom-vue-mixins';

export default {
    name: 'AdvancedItemList',
    props: [],
    components: {},  // most things are registered globally
    mixins: [currentUserInfoMixin, tenantInfoMixin],
    data() {
        return {
            advancedView: false,
            isInitialAdvancedViewSet: false,  // set true once we resolve what it should be - used to hide both lists until we know which to use, otherwise there are extra queries
            preferAdvancedLocalStorageKey: 'itemListTypePreferAdvanced',  //
        }
    },
    computed: {
        canAdd() {
            // TODO - base this on new backend permissions -- current front-end hiding is short-term
            if (this.$getTenantFlag('allow_any_internal_write_products', false)) {
                // check tenant flag for now... in future, we will have actual permissions
                return this.$currentUserInfo?.is_internal || false;
            }
            return this.$currentUserInfo?.is_paid_seat || false;
        },
    },
    mounted() {
        this.getPreferAdvancedFromLocalStorage();
        this.isInitialAdvancedViewSet = true;
    },
    methods: {
        startCreate() {
            if (!this.canAdd) {
                return;  // block if called from the empty list button
            }
            this.$refs.createModal.startCreate();
        },
        afterCreateComplete() {
            if (this.$refs.basicItemList) {
                this.$refs.basicItemList.refreshList(true);
            } else if (this.$refs.itemsObjectGrid) {
                this.$refs.itemsObjectGrid.reloadRows();
            }
            // TODO - refresh object grid when in advanced view
        },
        toggleAdvancedView() {
            // TODO - save this setting to local storage (browswer local storage)
            this.advancedView = !this.advancedView;
            this.setPreferAdvancedInLocalStorage();
        },
        // SET / GET FROM LOCAL STORAGE
        setPreferAdvancedInLocalStorage() {
            const key = this.preferAdvancedLocalStorageKey;
            const preferAdvanced = JSON.stringify(this.advancedView);
            console.log('Setting preferAdvancedLocalStorageKey in local storage', key, preferAdvanced);
            localStorage.setItem(key, preferAdvanced);
        },
        getPreferAdvancedFromLocalStorage() {
            const preferAdvancedRaw = localStorage.getItem(this.preferAdvancedLocalStorageKey);
            if (preferAdvancedRaw) {
                this.advancedView = JSON.parse(preferAdvancedRaw);
            } else {
                console.log('No advanced view preference found in local storage');
                // if here, then we don't set it, let the default be used
            }
        },
        clearPreferAdvancedFromLocalStorage() {
            localStorage.removeItem(this.preferAdvancedLocalStorageKey);
        },
    },
};
</script>
